// Polyfill for global
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import "./styles/main.css";
import fgvWarning from "./assets/warning_small_screen.png";

import './i18n';

if (typeof window !== 'undefined') {
  (window as any).global = window;
}

// Suppress "Support for defaultProps will be removed" warning from NextUI v1
const originalConsoleError = console.error;
console.error = (...args) => {
  if (typeof args[0] === "string" && /Support for defaultProps will be removed/.test(args[0])) {
    return;
  }
  originalConsoleError(...args);
};

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

const notSupportedRoot = ReactDOM.createRoot(
  document.getElementById("not_supported")!
);
const element = (
  <img
    id="not_supported_img"
    src={fgvWarning}
    alt="This survey is not designed to support small screens. If you want to join, please use computer."
  />
);
notSupportedRoot.render(element);
